(function GroupConfigureReservationsForm($, Adzuki)
{
	"use strict";

	Adzuki.onload('GroupRegistrations/configureReservations', init);

	function init()
	{
		$('.reservation-type').on('change', reservationTypeChange);
		$('.copy-pricing').on('click', copyPricing);
	}

	function reservationTypeChange()
	{
		var reservation_type          = $(this).val();
		var registration_id           = $(this).data('registration-id');
		var $existing_reservation_row = $('#registration-' + registration_id + '-existing-reservation');

		if (reservation_type === 'existing') {
			$existing_reservation_row.removeClass('hidden');
		} else {
			$existing_reservation_row.addClass('hidden');
		}
	}

	function copyPricing(ev)
	{
		var passenger_count = parseInt($(this).data('passenger-count'));
		var copy_from_row_id = 'passenger-pricing-row-' + (passenger_count - 1);
		var copy_to_row_id = 'passenger-pricing-row-' + passenger_count;
		var fields_to_copy;
		ev.preventDefault();

		// Get all the fields within the row
		fields_to_copy = $('#' + copy_from_row_id + ' input');
		$(fields_to_copy).each(function copyField(index, el) {
			$('#' + copy_to_row_id + ' input[data-field=' + $(el).data('field') + ']').val(($(el).val()));
		});
	}

}(jQuery, window.Adzuki || {}));